module.exports = __webpack_public_path__ + "img/attention.a45f4fe7.svg";